import {
  CASE_CARD_HEIGHT,
  DUAL_CANVAS_INCLUDED_PATHS,
  GALLERY_WIDTH,
  NAVBAR_HEIGHT,
  RIGHT_SIDEBAR_WIDTH,
} from './constants'

const getCanvasSize = (path: string, extraHeight = 0) => {
  const windowWidth = window.innerWidth
  const windowHeight = window.innerHeight
  const isDisplay1300 = windowWidth > 1300
  const CANVAS_X_PADDING = 8
  const leftSidebarWidth = GALLERY_WIDTH + CANVAS_X_PADDING
  let rightSidebarWidth = RIGHT_SIDEBAR_WIDTH as number
  const navbarHeight = NAVBAR_HEIGHT
  const caseCardHeight = DUAL_CANVAS_INCLUDED_PATHS.includes(path || '')
    ? CASE_CARD_HEIGHT
    : isDisplay1300
      ? CASE_CARD_HEIGHT
      : 146

  let height = extraHeight

  switch (path) {
    case '/all-in-one':
    case '/shade-guide-ai': {
      const STEPPER_HEIGHT = 70.02
      height += STEPPER_HEIGHT
      break
    }
    case '/digital-try-in': {
      const BUTTON_CONTAINER_HEIGHT = 66
      height += BUTTON_CONTAINER_HEIGHT
      rightSidebarWidth = 0
      break
    }
    case '/staining-studio/crown': {
      rightSidebarWidth = 0
      break
    }
    case '/staining-studio/stump-shade': {
      rightSidebarWidth = 0
      break
    }
    case '/full-layering/staining-corrections': {
      rightSidebarWidth = 0
      break
    }
    case '/micro-layering/staining': {
      rightSidebarWidth = 0
      break
    }
    case '/full-monolithic/staining': {
      rightSidebarWidth = 0
      break
    }
    case '/pfm-crown/staining-corrections': {
      rightSidebarWidth = 0
      break
    }
    case '/model-making/3d-printed-model-staining': {
      rightSidebarWidth = 0
      break
    }
    case '/matisse-lite/staining-studio': {
      rightSidebarWidth = 0
      break
    }
    case '/staining-studio/wash-bake': {
      rightSidebarWidth = 0
      break
    }
    case '/full-layering/wash-bake': {
      rightSidebarWidth = 0
      break
    }
    case '/pfm-crown/opaquer-staining': {
      rightSidebarWidth = 0
      break
    }
  }

  return {
    availableWidth: windowWidth - leftSidebarWidth - rightSidebarWidth,
    availableHeight: windowHeight - navbarHeight - caseCardHeight - height,
  }
}

export default getCanvasSize
